import React from "react";
import AttachmentAssessment from "../../Attachment/AttachmentAssessment";
import CrossAttachmentAssessment from "../../Attachment/CrossAttachmentAssessment";
// css comes in create_hw_finle.css

const PreUpload = ({ question, nextQuestion }) => {
  return (
    <>
      <div className="  preview_question_box">
        <div className=" col-12 my-3 preview_selected_question">
          <div className="pre_question_no">Q{nextQuestion + 1}</div>
          <div className="pre_question">{question.title}</div>
        </div>
        <div className="col-11 mx-5  mandatory_box">
        <div className="d-flex justify-content-between" style={{width:"100%", margin:"0"}}>
          <div>
            {question?.is_mandatory && <span>*Mandatory question</span>}
          </div>
          <div>
          {question?.correct_score && <span>{question?.correct_score} Marks</span>}
          </div>
        </div>
          {question?.attachments?.length > 0 && (
            <div className="ms-2 gap-2 d-flex">
              {question?.attachments?.map((attachment, index) => (
                <CrossAttachmentAssessment
                  key={index}
                  attachment={attachment}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PreUpload;
